export const getTopicBacklogCountBySize = <T extends { backlogSize?: number; msgBacklog?: number }>(
  subscriptions: Record<string, T> | undefined,
  backlogSize: number | undefined
) => {
  if (backlogSize === undefined) {
    return undefined
  }

  const matchedSubscription = Object.values(subscriptions || {}).find(
    subscription => Number(subscription.backlogSize) === Number(backlogSize)
  )

  return matchedSubscription === undefined ? undefined : Number(matchedSubscription.msgBacklog) || 0
}
